import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();





// import { projectsData } from "../projectData";

// export const ProjectPage = ({ darkMode, title }) => {
//   return (
//     <div className="flex justify-center items-center fixed inset-0 bg-opacity-50 z-10">
//       <div
//         className={`w-4/5 h-4/5 p-6 rounded-lg shadow-lg overflow-y-auto
//         ${darkMode ? "bg-[#181a1b] text-white" : "bg-white text-[#181a1b]"}`}
//       >
//         {/* Title */}
//         <h1 className="text-center text-4xl font-bold py-6">{title}</h1>

//         {/* Project Overview */}
//         <section className="mb-6">
//           <h2 className="text-2xl font-semibold">Project Overview</h2>
//           <p className="text-lg mt-2">
//             {projectsData[title]["Project Overview"]}
//           </p>
//         </section>

//         {/* Purpose of the Project */}
//         <section className="mb-6">
//           <h2 className="text-2xl font-semibold">Purpose of the Project</h2>
//           <p className="text-lg mt-2">
//             {projectsData[title]["Purpose of the Project"]}
//           </p>
//         </section>

//         {/* Tech Stack & GitHub */}
//         <div
//           className={`my-3 p-4 flex justify-between shadow rounded-md 
//           ${darkMode ? "bg-gray-800 text-white" : "bg-gray-100 text-black"}`}
//         >
//           <div>
//             <h3 className="font-bold">Tech Stack</h3>
//             {projectsData[title]["TechStack"].map((tech, index) => (
//               <span key={index} className="block text-sm opacity-80">
//                 {tech}
//               </span>
//             ))}
//           </div>
//           <div>
//             <h3 className="font-bold">GitHub</h3>
//             <a
//               href={projectsData[title]["github"]}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="underline text-sm opacity-80"
//             >
//               Repository
//             </a>
//           </div>
//         </div>

//         {/* Image */}
//         <div className="flex justify-center py-6">
//           <img
//             className="w-4/5 rounded-md shadow-lg"
//             src={projectsData[title]["Images"]["Final Render"]}
//             alt={`${title} - Final Render`}
//           />
//         </div>

//         {/* Challenges & Problems Solved */}
//         <section className="mt-6">
//           <h2 className="text-2xl font-semibold mb-3">
//             Challenges & Problems Solved
//           </h2>

//           {projectsData[title]["Challenges & Problems Solved"].map(
//             (challenge, index) => (
//               <div
//                 key={index}
//                 className={`mb-6 p-4 rounded-lg shadow 
//               ${
//                 darkMode ? "bg-gray-800 text-white" : "bg-gray-100 text-black"
//               }`}
//               >
//                 {/* Challenge Title */}
//                 <h3 className="text-xl font-bold">
//                   {index + 1}. {challenge.problemTitle}
//                 </h3>

//                 {/* Problem Description */}
//                 <p className="mt-2">
//                   <span className="font-semibold text-lg">
//                     Problem Description:
//                   </span>
//                   {` ${challenge.Problem}`}
//                 </p>

//                 {/* Issues Faced */}
//                 {challenge["Issues Faced"].length > 0 && (
//                   <div className="mt-3">
//                     <h4 className="font-semibold text-red-400">
//                       Issues Faced:
//                     </h4>
//                     <ul className="list-disc list-inside opacity-80 pl-4">
//                       {challenge["Issues Faced"].map((issue, idx) => (
//                         <li key={idx} className="py-1">
//                           {issue}
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 )}

//                 {/* Solution & Image */}
//                 <div className="flex flex-col lg:flex-row items-center gap-6 mt-4">
//                   {/* Solution Text */}
//                   <div className="flex-1">
//                     <p className="mt-3">
//                       <span className="font-semibold text-lg text-green-400">
//                         Solution :
//                       </span>
//                       {` ${challenge.Solution}`}
//                     </p>
//                   </div>

//                   {/* Challenge Image */}
//                   {challenge.Image && (
//                     <img
//                       className="w-full max-w-[300px] rounded-md shadow-md"
//                       src={challenge.Image}
//                       alt={challenge.problemTitle + " image"}
//                     />
//                   )}
//                 </div>
//               </div>
//             )
//           )}
//         </section>
//       </div>
//     </div>
//   );
// };
